import { useNavigate } from "react-router-dom";
import useAppState from "../../../context/AppContext";
import { APP_RETIREMENT_URLS } from "../../../const/AppConst";
import StickButtonsBloc from "../../common/StickButtonsBloc";
import { useForm } from "react-hook-form";
import InfoAttestationROBeneficiaryTemplate from "../../../components/info-beneficiary-template/InfoAttestationROBeneficiaryTemplate";

type InfoIdentityBlocFormData = {

}

export default function REInfoAttestationROBeneficiaryBloc() {

  const navigate = useNavigate();
  const {
    dispatch
  } = useAppState();

  const {
    register,
    setValue, 
    handleSubmit,
    formState: { errors },
  } = useForm<InfoIdentityBlocFormData>({
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: {
     
    }
  });

  const onNextAction = async () => {
    const nextUrl = APP_RETIREMENT_URLS.infoBeneficiaryPage
   
    dispatch({type: 'NEXT_INFO_STEP', path: nextUrl});
    navigate({
        pathname: nextUrl
    });         
  }

  const onPreviousAction = async () => {
    const url = APP_RETIREMENT_URLS.infoAttestationROPage
   
    dispatch({type: 'BACK_INFO_STEP', path: url});
    navigate({
        pathname: url
    });         
  }


  return (
    <form style={{width: '100%'}}>
        <div className='form-row page-content'>
           <InfoAttestationROBeneficiaryTemplate 
              register={register} 
              setValue={setValue} 
              errors={errors} 
           />
        </div>
         <StickButtonsBloc 
              showPreviousButton={true} 
              disabledPreviousButton={false} 
              nextAction={handleSubmit(onNextAction)} 
              showNextButton={true} 
              previousAction={onPreviousAction}/>
    </form>
  )
}